import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Voicemail } from '@material-ui/icons';
import * as lib from '~/dependencies';
import { useTryToCall } from '~/hooks';
import * as actions from '~/store/actions';
// import { clearHistoryCustomFilters } from '~/store/actions/call';
import * as actionTypes from '~/store/actions/actionTypes';
import {
  BoxTabs,
  ItemTab,
  VoiceMessageTab,
  VoiceButton,
  Badge,
} from './styles';

const getActiveCallsLenth = state => {
  return state.callCurrent.data.length;
};

export default function TabCallLogs({ setTab, tab }) {
  const dispatch = useDispatch();

  // HOOKS
  const tryToCall = useTryToCall();
  const location = lib.useLocation();
  const { t, i18n } = lib.useTranslation();

  // STATES
  const [canSeeAllCalls, setCanSeeAllCalls] = useState(false);

  // SELECTORS
  const auth = useSelector(state => state?.auth);
  const activeCallsLength = useSelector(getActiveCallsLenth);
  const voiceMessages = useSelector(state => state?.phone?.voiceMessages);
  const { heard, unheard } = voiceMessages;

  const handleMyCalls = () => {
    dispatch(actions.setPageOffset(1));
    dispatch(actions.resetHistoryFilterOptions());
    // dispatch(clearHistoryCustomFilters());
    // dispatch({ type: actionTypes.RESET_CALL_LOGS_PAGES });
    dispatch({
      type: actionTypes.SET_CURRENT_HISTORY_TAB,
      payload: ['My Calls'],
    });
    setTab(0);
  };

  const handleAllCalls = () => {
    dispatch(actions.setPageOffset(1));
    dispatch(actions.resetHistoryFilterOptions());
    // dispatch(clearHistoryCustomFilters());
    // dispatch({ type: actionTypes.RESET_CALL_LOGS_PAGES });
    dispatch({
      type: actionTypes.SET_CURRENT_HISTORY_TAB,
      payload: ['All Calls'],
    });
    setTab(1);
  };

  useEffect(() => {
    dispatch({
      type: actionTypes.SET_CURRENT_HISTORY_TAB,
      payload: ['My Calls'],
    });
  }, [dispatch]);

  useEffect(() => {
    if (auth?.isAdmin) {
      setCanSeeAllCalls(true);
    } else if (auth?.userPermissions) {
      const {
        call_log_access,
        extensions,
        numbers,
        queues,
      } = auth.userPermissions;

      if (call_log_access === 'all') {
        setCanSeeAllCalls(true);
      }
      if (call_log_access === 'limited' && (extensions || numbers || queues)) {
        setCanSeeAllCalls(true);
      }
    } else {
      setCanSeeAllCalls(false);
    }
  }, [setCanSeeAllCalls, auth]);

  const allowCallVoiveMail =
    unheard > 0 &&
    activeCallsLength === 0 &&
    location?.pathname?.endsWith('app/');

  return (
    <BoxTabs>
      {allowCallVoiveMail && (
        <VoiceMessageTab>
          <VoiceButton
            name="hisotry-mail-btn"
            title={t('screens.phone.components.tab.voicemail', {
              unheard,
              heard,
            })}
            onClick={() => tryToCall('*71')}>
            <Badge>
              <center>{unheard >= 10 ? '+9' : unheard}</center>
            </Badge>
            <Voicemail className="voice-mail-btn" />
          </VoiceButton>
        </VoiceMessageTab>
      )}
      <ItemTab
        lang={i18n.language}
        className={tab === 0 && 'active'}
        onClick={handleMyCalls}
        data-test-id="my-calls-btn">
        <span>{t('screens.phone.components.tab.myCalls')}</span>
      </ItemTab>
      {canSeeAllCalls && (
        <ItemTab
          lang={i18n.language}
          className={tab === 1 && 'active'}
          onClick={handleAllCalls}
          data-test-id="all-calls-btn">
          <span>{t('screens.phone.components.tab.allCalls')}</span>
        </ItemTab>
      )}
    </BoxTabs>
  );
}

TabCallLogs.defaultProps = {
  tab: 0,
  setTab: () => {},
};

TabCallLogs.propTypes = {
  tab: lib.PropTypes.number,
  setTab: lib.PropTypes.func,
};
